import { CDate, ICalendarDay, IOrder, IPriceComponent, PriceComponent } from '@curbnturf/entities';
import { createReducer, on } from '@ngrx/store';
import * as OrderActions from './order.actions';

export interface OrderState {
  order: IOrder; // the current order the user is working on
  priceComponents: IPriceComponent[];
  days: ICalendarDay[];
  error?: string; // last error (if any)
  priceError?: string; // last price error (if any)
}

// required to be an exported function
export function buildOrder(order?: IOrder): IOrder {
  if (!order) {
    return {};
  }

  const newOrder: IOrder = { ...order };

  if (newOrder.date) {
    newOrder.date = new CDate(newOrder.date);
  }

  if (newOrder.priceComponents) {
    newOrder.priceComponents = newOrder.priceComponents.map((price) => new PriceComponent(price));
  }

  newOrder.built = true;

  return newOrder;
}

export const initialState: OrderState = {
  order: {},
  priceComponents: [],
  days: [],
};

export const orderReducer = createReducer(initialState,
  on(OrderActions.setOrder, (state, action) => {
    return {
      ...state,
      order: buildOrder(action.order),
    };
  }),
  on(OrderActions.setOrderSite, (state, action) => {
    return {
      ...state,
      order: buildOrder({ ...state.order, siteId: action.siteId }),
    }
  }),
  on(OrderActions.priceFilled, (state, action) => {
    if (action.reservation && action.reservation.priceComponents) {
      const priceComponents = action.reservation.priceComponents;

      return {
        ...state,
        order: buildOrder({ ...state.order, priceComponents }),
        priceComponents,
        priceError: undefined,
      };
    }

    return state;
  }),
  on(OrderActions.daysFilled, (state, action) => {
    if (action.days) {
      return {
        ...state,
        days: action.days,
      };
    }

    return state;
  }),
  on(OrderActions.orderError, (state, action) => {
    const error = action.error?.error?.message || action.error?.message || action.error;

    return {
      ...state,
      error,
    };
  }),
  on(OrderActions.priceError, (state, action) => {
    const error = action.error?.error?.message || action.error?.message || action.error;

    return {
      ...state,
      priceError: error,
    };
  }),
);
